import { render } from "./DartsLogo.vue?vue&type=template&id=0a356d9a&lang=pug"
const script = {}

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/WP Darts/Admin Webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__